/* eslint-disable @next/next/no-img-element */
import usePrefix from '@/hooks/usePrefix';
import { Button, Divider, Layout } from 'antd';
import dayjs from 'dayjs';
import { DownOutlined, UpOutlined } from '@/components2/Icons';
import { ReactElement, useEffect, useState } from 'react';
import Image from 'next/image';
import { CDN2 } from '@/helpers/api';
import ButtonStore from '@/components/ButtonStore';
import ButtonSocial from '@/components/ButtonSocial';

const { Footer } = Layout;

export default function AntFooterSearch(): ReactElement {
  const [isMobile, setIsMobile] = useState(false);

  function resizeMobile() {
    setIsMobile(window.innerWidth < 768);
  }

  useEffect(() => {
    window.addEventListener('resize', resizeMobile);
    setIsMobile(window.innerWidth < 768);
    return () => {
      window.removeEventListener('resize', resizeMobile);
    };
  }, []);
  useEffect(() => {
    if (isMobile) {
      setShowItemsFooterOne(false);
      setShowItemsFooterTwo(false);
      setShowItemsFooterThree(false);
      setShowItemsFooterFour(false);
    } else {
      setShowItemsFooterOne(true);
      setShowItemsFooterTwo(true);
      setShowItemsFooterThree(true);
      setShowItemsFooterFour(true);
    }
  }, [isMobile]);

  const [showItemsFooterOne, setShowItemsFooterOne] = useState(false);
  const [showItemsFooterTwo, setShowItemsFooterTwo] = useState(false);
  const [showItemsFooterThree, setShowItemsFooterThree] = useState(false);
  const [showItemsFooterFour, setShowItemsFooterFour] = useState(false);

  const prefix = usePrefix();
  return (
    <div className="w-full self-center">
      <Footer className="flex flex-col !p-0 ">
        <div className="flex flex-col md:flex-row justify-center items-center space-y-10 md:space-y-0 subFooter px-4 py-8 md:py-4">
          <p className="items-center">
            © Copyright On Air Parking {dayjs().format('YYYY')}
          </p>
          <div className="flex flex-col md:mx-12">
            <a
              href="https://www.bbb.org/us/ca/westlake-village/profile/parking-facilities/on-air-parking-1236-92090148"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="hover:scale-110"
            >
              <Image
                src={CDN2() + '/staticmyapp/bbba.webp'}
                alt="BBB Rating"
                width={100}
                height={42}
                loading="lazy"
              />
            </a>
          </div>
          <ButtonSocial />
          <div className="md:ml-12 flex flex-row gap-x-4">
            <ButtonStore width={120} height={42} />
          </div>
        </div>
      </Footer>
    </div>
  );
}
